import { handleErrorException, loading, success } from 'State/actions';
import { PhysicalEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getPhysicalData = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PHYSICAL_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Physical/GetPhysicals',
        filtersOptions
      );
      dispatch(success(types.PHYSICAL_DATA_LIST, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching physical data. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.PHYSICAL_DATA_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PHYSICAL_DATA_LOADING, false));
    }
  };
};

export const printPhysicalData = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_PHYSICAL_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Physical/GetPhysicalPrint',
        printRequestData
      );
      if (response.data.Data) {
        const data = response.data.Data[PhysicalEnum.PrintData];
        if (data) {
          dispatch(loading(types.SET_PRINT_DATA, data));
        }
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while creating PDF. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.PRINT_PHYSICAL_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PRINT_PHYSICAL_LOADING, false));
    }
  };
};

export const clearPhysicalError = () => {
  return {
    type: types.CLEAR_PHYSICAL_ERROR,
  };
};

export const clearPhysicalGridData = () => {
  return {
    type: types.PHYSICAL_CLEAR_GRID_DATA,
  };
};

export const deletePhysical = physicalList => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PHYSICAL_DATA_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Physical/DeletePhysicals',
        physicalList
      );
      dispatch(success(types.PHYSICAL_DATA_DELETE, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while deleting physical(s). Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.PHYSICAL_DATA_DELETE_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PHYSICAL_DATA_LOADING, false));
    }
  };
};

export const clearAdjustmentGridError = () => {
  return {
    type: types.CLEAR_PHYSICAL_LIST_ERROR,
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/PhysicalList/actions.js